(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["excello-reviews"]) return;
  try {
    
(() => {
  const placeReviewAction = () => {
    document.querySelectorAll('details.excello-reviews .jm-review-widget').forEach(widget => {
      const action = widget.querySelector('.jm-action-buttons');
      if (action && action.parentElement !== widget) {
        action.classList.add('excello-review-action-bottom');
        widget.append(action);
      }
    });
  };
  placeReviewAction();
  const reviews = document.querySelector('details.excello-reviews');
  if (reviews) new MutationObserver(placeReviewAction).observe(reviews, { childList: true, subtree: true });
  document.addEventListener('click', event => {
    const target = event.target instanceof Element ? event.target : null;
    const link = target?.closest('.jdgm-prev-badge, a[href*="#judgeme_product_reviews"], a[href="#reviews"]');
    if (!link || link.closest('product-card, .product-card, #judgeme_product_reviews')) return;
    const accordion = document.querySelector('details.excello-reviews');
    if (!accordion) return;
    accordion.open = true;
    requestAnimationFrame(() => requestAnimationFrame(() => {
      accordion.scrollIntoView({ behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'start' });
    }));
  }, true);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["excello-shop-by-colour"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.excello-shades__card').forEach(link => {
    const current = new URL(location.href),url = new URL(link.href),gender = current.searchParams.get('excello_gender');
    if (['men','women','unisex'].includes(gender)) url.searchParams.set('excello_gender', gender);
    for (const key of ['preview_theme_id','_ab','_fd','_sc']) if (current.searchParams.has(key)) url.searchParams.set(key,current.searchParams.get(key));
    link.href = url.href;
  });
  document.querySelectorAll('.excello-shades').forEach(async section => {
    const gender = new URL(location.href).searchParams.get('excello_gender');
    if (!['men','women','unisex'].includes(gender)) return;
    const rail = section.querySelector('.excello-shades__rail');
    rail.hidden = true;
    try {
      const { loadCollection } = await import(section.dataset.colourFeed);
      const products = await loadCollection('all',section.dataset.root);
      const colours = new Set(products.filter(item=>item.available&&!item.hidden&&item.gender===gender).map(item=>item.colour));
      for (const link of rail.querySelectorAll('.excello-shades__card')) link.parentElement.hidden = !colours.has(link.dataset.colour);
      rail.hidden = false;
      section.hidden = ![...rail.children].some(item=>!item.hidden);
    } catch {section.hidden = true;}
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"] && !Shopify.designMode) return;
  try {
    
  const retailPhone = '919339044991';
  const retailText = encodeURIComponent('Hi EXCELLO, I need help with a product/order.');
  const mobileDevice = /Android|iPhone|iPad|iPod/i.test(navigator.userAgent) || (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);
  const webChat = 'https://web.whatsapp.com/send?phone=' + retailPhone + '&text=' + retailText;
  const appChat = 'whatsapp://send?phone=' + retailPhone + '&text=' + retailText;
  const browserChat = 'https://api.whatsapp.com/send?phone=' + retailPhone + '&text=' + retailText;
  const prepareRetailChat = () => {
    document.querySelectorAll('footer a[aria-label="Whatsapp"]').forEach((link) => {
      if (link.dataset.retailChatReady) return;
      link.dataset.retailChatReady = 'true';
      link.href = mobileDevice ? browserChat : webChat;
      if (!mobileDevice) return;
      link.target = '_self';
      link.addEventListener('click', (event) => {
        if (event.button !== 0 || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return;
        event.preventDefault();
        let fallback;
        const cancelFallback = () => {
          clearTimeout(fallback);
          document.removeEventListener('visibilitychange', onVisibility);
          window.removeEventListener('pagehide', cancelFallback);
        };
        const onVisibility = () => {
          if (document.hidden) cancelFallback();
        };
        document.addEventListener('visibilitychange', onVisibility);
        window.addEventListener('pagehide', cancelFallback, { once: true });
        fallback = setTimeout(() => {
          cancelFallback();
          if (!document.hidden) window.location.assign(browserChat);
        }, 1800);
        window.location.assign(appChat);
      });
    });
  };
  prepareRetailChat();
  document.addEventListener('shopify:section:load', prepareRetailChat);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
